// Flow configuration for step-by-step procrastination quiz
export const procrastinationQuizStepByStepFlow = {
  themeOptions: {
    showProgress: true,
    progressStyle: 'milestones', // 'bar' | 'dots' | 'milestones'
    allowBackNavigation: true,
    autoProgressOnAnswer: true,
    milestones: [
      'Getting Started',
      'Understanding You', 
      'Your Results'
    ]
  },
  steps: [
    { type: 'information', content: { 
      title: 'Procrastination Quiz: Discover Your Archetype',
      description: 'Are you tired of putting things off? Do you find yourself stuck in cycles of delay and regret? You\'re not alone, and more importantly, there\'s a way out.',
      markdown: `## Why Do We Procrastinate?

Procrastination isn't just about being lazy—it's a complex behavior pattern that affects even the most motivated people. The truth is, different people procrastinate for different reasons:

- **Perfectionists** delay starting because they want everything to be flawless
- **Dreamers** get excited about new ideas but struggle with follow-through  
- **Busy professionals** stay active but avoid the truly important work
- **Action-oriented people** may still hit roadblocks with certain types of tasks

Understanding your specific procrastination archetype is the key to breaking free from these patterns once and for all.

## Introducing the Procrastination Quiz: Your Personal Assessment

Our **Procrastination Quiz** is designed to identify your unique procrastination archetype and provide you with a personalized action plan. This isn't just another generic "beat procrastination" guide—it's a tailored approach based on your specific patterns and tendencies.

**How It Works:** Through 8 carefully crafted questions, we'll analyze your reactions to new tasks, your response to distractions, your planning habits, and how you handle setbacks. Each question reveals important insights about your procrastination style, and your answers are scored to determine which of four distinct archetypes you belong to.

## What You'll Discover: Your Procrastination Archetype

The quiz reveals one of four procrastination archetypes:

- **The Paralyzed Perfectionist**: You overthink everything and fear failure more than anything else
- **The Scattered Dreamer**: You have great ideas but struggle with consistent follow-through
- **The Busy Procrastinator**: You stay active but avoid the truly important tasks
- **The Action Hero**: You already have strong habits but need advanced optimization

Each archetype comes with its own set of challenges and requires different strategies to overcome procrastination effectively.

---

**Ready to discover your procrastination archetype and get your personalized action plan?** 

The following 8 questions will help us identify your specific patterns and provide you with personalized strategies to overcome procrastination.`
    }},
    { type: 'question', questionRef: 0 },
    { type: 'question', questionRef: 1 },
    { type: 'question', questionRef: 2 },
    { type: 'question', questionRef: 3 },
    { type: 'question', questionRef: 4 },
    { type: 'question', questionRef: 5 },
    { type: 'question', questionRef: 6 },
    { type: 'question', questionRef: 7 },
  ]
};